import Types from "./types";
import { B2cInventoryServiceAU as B2cInventoryService, BffDataAU, CheckoutDrivaService, CheckoutService, ListingServiceAU as ListingService, ListingServiceAUV2 } from "../../../service";
import { FINANCE_TYPE } from "../../../constants/checkout-constants";
import { EXPERIMENT_TYPE, ZERO_DP_VARIANTS } from "../../../constants/optimize-constants";
import { API_SOURCE } from "../../../constants/app-constants";

const fetchDetails = () => ({
    type: Types.FETCH_CAR_DETAILS
});

const fetchCarDetailsSuccess = (data) => ({
    type: Types.FETCH_CAR_DETAILS_SUCCESS,
    data
});

const fetchCarDetailsFailure = (error) => ({ type: Types.FETCH_CAR_DETAILS_FAILURE, error });

const fetchCarDetails = (carId, params = {}) => (dispatch, getState) => {
    dispatch(fetchDetails());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin, userGeoData},
        tradeIn: {
            tradeInToggleSelected
        },
        abExperiment: {
            desktopCdpEw,
            desktopComingSoon
            // desktopPremiumFeatures
        }
    } = getState();
    const {data: ewVariant} = desktopCdpEw || {};
    const comingSoonTdVariant = desktopComingSoon?.data || EXPERIMENT_TYPE.VARIANT_A;
    // const {data: premiumFeatureVariant} = desktopPremiumFeatures || {};
    params = {
        ...(params || {}),
        zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP,
        ...(tradeInToggleSelected && ({tradeIn: tradeInToggleSelected })),
        cdpRequest: true, // used for recently viewed cars /search-page API ordering and differentiate with v1/vehicle in BE
        ewVariant,
        comingSoonTdVariant,
        // TILL IMPERFECTION A/B is not scaled
        premiumFeatureVariant: "VARIANT_B"
    };
    if (!(params || {}).userFinanceType) {
        params = {...(params || {}), userFinanceType: FINANCE_TYPE.CARS24};
    }

    if (userGeoData?.postalCode) {
        params = {
            ...(params || {}),
            geoPinCode: userGeoData?.postalCode
        };
    }

    return new Promise((resolve, reject) => {
        ListingServiceAUV2.fetchCarDetailV3(carId, isGuestLogin ? null : secureToken, params, API_SOURCE.WEB_APP, userGeoData)
            .then((response) => {
                dispatch(fetchCarDetailsSuccess(response.data));
                return resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchCarDetailsFailure(error));
                reject(error);
            });
    });
};

const fetchSimilarCarsInit = () => ({
    type: Types.FETCH_SIMILAR_CARS
});

const fetchSimilarCarsSuccess = (data) => ({
    type: Types.FETCH_SIMILAR_CARS_SUCCESS,
    data
});

const fetchSimilarCarsFailure = (error) => ({
    type: Types.FETCH_SIMILAR_CARS_FAILURE,
    error
});

const fetchSimilarCars = (carId, params) => (dispatch, getState) => {
    dispatch(fetchSimilarCarsInit());
    const {
        user: {
            secureToken,
            isUserZeroDpVariant,
            userGeoData
        },
        tradeIn: {
            userTradeInData,
            tradeInToggleSelected
        }
    } = getState();

    // Trade-in toggle selected or not
    const { tradeIn = false } =  userTradeInData || {};
    params = {
        ...(params || {}),
        zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP,
        ...(tradeIn && ({tradeIn: tradeInToggleSelected }))
    };

    return new Promise((resolve, reject) => {
        ListingService.fetchSimilarCars(carId, params, secureToken, userGeoData)
            .then((response) => {
                dispatch(fetchSimilarCarsSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchSimilarCarsFailure(error));
                reject(error);
            });
    });
};

const fetchSeoSimilarCarsInit = () => ({
    type: Types.FETCH_SEO_SIMILAR_CARS
});

const fetchSeoSimilarCarsSuccess = (data) => ({
    type: Types.FETCH_SEO_SIMILAR_CARS_SUCCESS,
    data
});

const fetchSeoSimilarCarsFailure = (error) => ({
    type: Types.FETCH_SEO_SIMILAR_CARS_FAILURE,
    error
});

const fetchSeoSimilarCars = (carId, params) => (dispatch, getState) => {
    dispatch(fetchSeoSimilarCarsInit());
    const {
        user: {
            secureToken
        }
    } = getState();
    return new Promise((resolve, reject) => {
        ListingService.fetchSeoSimilarCars(carId, params, secureToken)
            .then((response) => {
                dispatch(fetchSeoSimilarCarsSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchSeoSimilarCarsFailure(error));
                reject(error);
            });
    });
};

const updateCarDetailsSSRStatus = (isSSR) => ({
    type: Types.UPDATE_SSR_STATUS,
    isSSR
});

const setGsGalleryData = (data) => ({
    type: Types.SET_GS_GALLERY_DATA,
    data
});

const getAvailabilityInfoRequest = () => ({
    type: Types.GET_DELIVERY_INFO_REQUEST
});

const getAvailabilityInfoSuccess = (data, pincode) => ({
    type: Types.GET_DELIVERY_INFO_SUCCESS,
    data,
    pincode
});

const getAvailabilityInfoFailure = (error) => ({
    type: Types.GET_DELIVERY_INFO_FAILURE,
    error
});

const getAvailabilityInfo = (appointmentId, cityCode) => (dispatch) => {
    dispatch(getAvailabilityInfoRequest());
    return new Promise((resolve, reject) => {
        B2cInventoryService.getPickupLocation(appointmentId, cityCode)
            .then((response) => {
                dispatch(getAvailabilityInfoSuccess(response.data, cityCode));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(getAvailabilityInfoFailure(error));
                reject(error);
            });
    });
};

const getDrivaRoiDetailsRequest = () => ({
    type: Types.GET_DRIVA_ROI_REQUEST
});

const getDrivaRoiDetailsSuccess = (data) => ({
    type: Types.GET_DRIVA_ROI_SUCCESS,
    data
});

const getDrivaRoiDetailsFailure = (error) => ({
    type: Types.GET_DRIVA_ROI_FAILURE,
    error
});

const getDrivaRoiDetails = (params) => (dispatch, getState) => {
    dispatch(getDrivaRoiDetailsRequest());
    const { user: { secureToken}} = getState();
    return new Promise((resolve, reject) => {
        CheckoutDrivaService.getDrivaRoiDetails(secureToken, params)
            .then((response) => {
                dispatch(getDrivaRoiDetailsSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(getDrivaRoiDetailsFailure(error));
                reject(error);
            });
    });
};

const updateLoginFetchCarDetailCompleted = (data) => ({
    type: Types.UPDATE_LOGIN_CAR_DETAIL_FETCH_COMPLETED,
    data
});

const setCurrentDeliveryTimeline = (data) => ({
    type: Types.SET_CURRENT_DELIVERY_TIMELINE,
    data
});

const fetchInspectionReportDataSuccess = (data) => ({
    type: Types.FETCH_INSPECTION_REPORT_DATA_SUCCESS,
    data
});

const fetchInspectionReportDataFailure = () => ({
    type: Types.FETCH_INSPECTION_REPORT_DATA_FAILURE
});

const fetchInspectionReportData = (params) => (dispatch, getState) => {
    const { user: { secureToken}} = getState();
    return new Promise((resolve, reject) => {
        BffDataAU.fetchInspectionReportDataApi(secureToken, params)
            .then((response) => {
                dispatch(fetchInspectionReportDataSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchInspectionReportDataFailure());
                reject(error);
            });
    });
};

const setRedirectRoute = (data) => ({
    type: Types.SET_REDIRECT_ROUTE,
    data
});

const setShowHubLocationModalInit = (showHubLocationModal) => ({
    type: Types.SET_SHOW_HUB_LOCATION_MODAL,
    showHubLocationModal
});

const setShowHubLocationModal = (data) => async (dispatch) => {
    dispatch(setShowHubLocationModalInit(data));
};

const fetchCmsConfigInit = () => ({
    type: Types.FETCH_CMS_CONFIG
});

const fetchCmsConfigSuccess = (data) => ({
    type: Types.FETCH_CMS_CONFIG_SUCCESS,
    data
});

const fetchCmsConfigFailure = (error) => ({
    type: Types.FETCH_CMS_CONFIG_FAILURE,
    error
});

const fetchCmsConfig = (params) => (dispatch) => {
    dispatch(fetchCmsConfigInit());
    return new Promise((resolve, reject) => {
        BffDataAU.getCmsContent(params)
            .then((response) => {
                dispatch(fetchCmsConfigSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchCmsConfigFailure(error));
                reject(error);
            });
    });
};

const setSelectedEwPlan = (data) => ({
    type: Types.SET_SELECTED_EW_PLAN,
    data
});

const setFomoNudgeData = (data) => ({
    type: Types.SET_FOMO_NUDGE_DATA,
    data
});

const setCarSeenCount = (data) => ({
    type: Types.SET_CAR_SEEN_COUNT,
    data
});
const updateExtendedWarrantySelection = (extendedWarrantySelected) => ({
    type: Types.UPDATE_EXTENDED_WARRANTY_SELECTED,
    extendedWarrantySelected
});

const fetchLeadAppointmentInit = () => ({
    type: Types.FETCH_LEAD_APPOINTMENT_INIT
});

const fetchLeadAppointmentSuccess = (data) => ({
    type: Types.FETCH_LEAD_APPOINTMENT_SUCCESS,
    data
});

const fetchLeadAppointmentFailure = (error) => ({
    type: Types.FETCH_LEAD_APPOINTMENT_FAILURE,
    error
});

const fetchLeadAppointment = (appointmentId) => (dispatch, getState) => {
    dispatch(fetchLeadAppointmentInit());
    const { user: { secureToken } } = getState();

    return new Promise((resolve, reject) => {
        CheckoutService.getLeadAppointment(appointmentId, secureToken)
            .then((response) => {
                dispatch(fetchLeadAppointmentSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchLeadAppointmentFailure(error));
                reject(error);
            });
    });
};

const reloadCarDetails = (data) => ({
    type: Types.RELOAD_CAR_DETAILS,
    data
});

export {
    fetchCarDetails,
    updateCarDetailsSSRStatus,
    fetchSimilarCars,
    setGsGalleryData,
    getAvailabilityInfo,
    getDrivaRoiDetails,
    fetchSeoSimilarCars,
    updateLoginFetchCarDetailCompleted,
    setCurrentDeliveryTimeline,
    fetchInspectionReportData,
    setRedirectRoute,
    setShowHubLocationModal,
    fetchCmsConfig,
    setFomoNudgeData,
    setCarSeenCount,
    updateExtendedWarrantySelection,
    setSelectedEwPlan,
    fetchLeadAppointment,
    reloadCarDetails
};
